"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _material = require("@mui/material");

var _googleMapsReact = require("google-maps-react");

var _reactPlacesAutocomplete = _interopRequireWildcard(require("react-places-autocomplete"));

var _style = _interopRequireDefault(require("./style"));

var _react2 = require("@emotion/react");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class AutocompleteGooglePlaces extends _react.default.PureComponent {
  constructor(props) {
    super(props);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.hanldeOnSelect = this.hanldeOnSelect.bind(this);
    this.state = {
      textoGoogle: null
    };
  }

  handleOnChange(event) {
    this.setState({
      textoGoogle: event
    });
  }

  hanldeOnSelect(event) {
    this.setState({
      textoGoogle: event
    });
    (0, _reactPlacesAutocomplete.geocodeByAddress)(event).then(results => {
      const localidad = _lodash.default.chain(results[0].address_components).find(a => a.types[1] == 'political').get('short_name').value();

      const label = results[0].formatted_address;
      const google_place_id = results[0].place_id;
      const lat = results[0].geometry.location.lat();
      const lng = results[0].geometry.location.lng();
      const name = results[0].address_components[0].long_name;
      this.props.onSuggestionSelected(null, {
        suggestion: {
          label,
          localidad,
          value: google_place_id,
          lat,
          lng,
          name
        }
      });
    }).catch(error => console.error(error));
  }

  render() {
    const {
      textoGoogle
    } = this.state;
    const {
      codigoPais,
      value
    } = this.props;
    return (0, _react2.jsx)(_reactPlacesAutocomplete.default, {
      value: textoGoogle !== null ? textoGoogle : value,
      searchOptions: {
        types: ['(cities)'],
        // En caso de que codigoPais sea undefined funciona sin restringir al pais.
        componentRestrictions: {
          country: codigoPais
        }
      },
      shouldFetchSuggestions: textoGoogle ? textoGoogle.length > 3 : false,
      onChange: this.handleOnChange,
      onSelect: this.hanldeOnSelect
    }, ({
      getInputProps,
      suggestions,
      getSuggestionItemProps,
      loading
    }) => (0, _react2.jsx)("div", {
      css: _style.default.container
    }, (0, _react2.jsx)(_material.TextField, {
      fullWidth: true,
      placeholder: "Busque su ciudad...",
      InputProps: {
        classes: {
          input: _style.default.input
        },
        ...getInputProps()
      }
    }), (0, _react2.jsx)(_material.Paper, {
      square: true
    }, loading && (0, _react2.jsx)(_material.MenuItem, {
      component: "div",
      key: "loading-item"
    }, (0, _react2.jsx)("div", null, "Cargando...")), _lodash.default.map(suggestions, suggestion => (0, _react2.jsx)(_material.MenuItem, {
      selected: suggestion.active,
      component: "div",
      key: suggestion.description
    }, (0, _react2.jsx)("div", getSuggestionItemProps(suggestion), suggestion.active ? (0, _react2.jsx)("span", {
      style: {
        fontWeight: 300
      }
    }, suggestion.description) : (0, _react2.jsx)("strong", {
      style: {
        fontWeight: 500
      }
    }, suggestion.description)))))));
  }

}

;

class MapContainer extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      places: []
    };
    this.showPlace = this.showPlace.bind(this);
    this.mapRef = /*#__PURE__*/_react.default.createRef();
  }

  showPlace(place) {
    this.setState(prevState => ({
      places: [...prevState.places, place]
    }));
    this.mapRef.current.map.setCenter(place.geometry.location);
  }

  render() {
    return (0, _react2.jsx)("div", {
      className: "map-container"
    }, (0, _react2.jsx)(AutocompleteGooglePlaces, {
      onPlaceChanged: this.showPlace
    }), (0, _react2.jsx)(_googleMapsReact.Map, {
      ref: this.mapRef,
      google: this.props.google,
      className: "map",
      zoom: 4,
      initialCenter: this.props.center
    }, this.state.places.map((place, i) => {
      return (0, _react2.jsx)(_googleMapsReact.Marker, {
        key: i,
        position: place.geometry.location
      });
    })));
  }

}

var _default = (0, _googleMapsReact.GoogleApiWrapper)({
  apiKey: `${process.env.REACT_APP_GOOGLE_MAP_API_KEY}`,
  libraries: ["places"]
})(MapContainer);

exports.default = _default;